export default __webpack_public_path__ + "static/media/T4E.37b25797.png";